import React from 'react';
import { Button, Dropdown, Menu } from 'semantic-ui-react';

import { InputTimeout } from 'src/componentes/semantic-ui-extended';
import { Filtros, nombres } from '../filtros';

interface Props {
    cantidadDeApoderados: number;
    cargando: boolean;
    filtros: Filtros;
    alCambiarFiltros(filtros: Filtros): void;
    alPresionarRecargar(): void;
    alCambiarTextoDelBuscador(texto: string): void;
}

const MenuTabla: React.FunctionComponent<Props> = props => {
    const {
        cantidadDeApoderados,
        cargando,
        filtros,
        alCambiarFiltros,
        alPresionarRecargar,
        alCambiarTextoDelBuscador,
    } = props;

    const textoFiltroDeudores = nombres.deudores[filtros.deudores];
    const textoFiltroPlanMatriculas = nombres.plan[filtros.plan];
    const textoFiltroSede = nombres.sede[filtros.sede];

    return (
        <Menu borderless size='large' attached='top' style={{ backgroundColor: '#f0f0ff' }}>
            <Menu.Item fitted='vertically'>
                <Button
                    style={{ height: '40px', width: '40px' }}
                    basic
                    icon='refresh'
                    loading={cargando}
                    onClick={alPresionarRecargar}
                />
            </Menu.Item>

            <Menu.Item fitted='vertically'>
                <InputTimeout
                    style={{ height: '40px', width: '22em' }}
                    icon='search'
                    milliseconds={300}
                    placeholder='nombre, rut, nº de contrato o nº de pagaré'
                    onTimeout={(_e, { value }) => alCambiarTextoDelBuscador(value)}
                    enableLoader={text => text.length >= 3}
                    autoFocus
                />
            </Menu.Item>

            <Dropdown fitted='vertically' text={textoFiltroDeudores} item>
                <Dropdown.Menu>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltros({ ...filtros, deudores: 'todos' });
                        }}
                    >
                        {nombres.deudores.todos}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltros({ ...filtros, deudores: 'deudores' });
                        }}
                    >
                        {nombres.deudores.deudores}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltros({ ...filtros, deudores: 'nodeudores' });
                        }}
                    >
                        {nombres.deudores.nodeudores}
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>

            <Dropdown fitted='vertically' text={textoFiltroPlanMatriculas} item>
                <Dropdown.Menu>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltros({ ...filtros, plan: 'todos' });
                        }}
                    >
                        {nombres.plan.todos}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltros({ ...filtros, plan: 'anual' });
                        }}
                    >
                        {nombres.plan.anual}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltros({ ...filtros, plan: 'intensivo' });
                        }}
                    >
                        {nombres.plan.intensivo}
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>

            <Dropdown fitted='vertically' text={textoFiltroSede} item>
                <Dropdown.Menu>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltros({ ...filtros, sede: 'todos' });
                        }}
                    >
                        {nombres.sede.todos}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltros({ ...filtros, sede: 'alameda' });
                        }}
                    >
                        {nombres.sede.alameda}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltros({ ...filtros, sede: 'san-fernando' });
                        }}
                    >
                        {nombres.sede['san-fernando']}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltros({ ...filtros, sede: 'uchile' });
                        }}
                    >
                        {nombres.sede.uchile}
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>

            <Menu.Item position='right'>{cantidadDeApoderados} apoderados</Menu.Item>
        </Menu>
    );
};

export default MenuTabla;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/BuscarApoderado/componentes/MenuTabla.tsx